import axios from 'axios';  

import { get, post, put } from '../utils/apiUtils';

// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_persistence/node_execution`;
const API_RESERVED = `/api/v1/bluemormon/pipeline/task_service/reserve_task`;
const API_SAVE = `/api/v1/bluemormon/pipeline/task_service/save`;
const API_SUBMIT = `/api/v1/bluemormon/pipeline/task_service/submit`




/**
 * Update system settings
 * @param {Object} getWaitingTask - fetch waiting task
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getWaitingTasks = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/fetch`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating system settings:', error);
    throw error;
  }
};


/**
 * @param {Object} filters - Filter parameters
 * @returns {Promise<Object>} Promise resolving to usage statistics
 */
export const fetchTaskCount = async (filter = {}) => {
  try {
    const response = await post(`${API_URL}/count`, filter);
    return response.count;
  } catch (error) {
    console.error(`Error fetching usage for waiting task count:`, error);
    throw error;
  }
};

/**
 * Get knowledge base usage statistics
 * @param {Object} payload - payload body
 * @returns {Promise<Object>} Promise resolving to usage statistics
 */
export const fetchTaskByPagination = async (skip, limit, payload = {}) => {
  try {
    const response = await post(`${API_URL}/fetch?skip=${skip}&limit=${limit}`, payload);
    return response;
  } catch (error) {
    console.error(`Error fetching usage for waiting task pagination:`, error);
    throw error;
  }
};


/**
 * Get knowledge base usage statistics
 * @param {Object} payload - payload body
 * @returns {Promise<Object>} Promise resolving to usage statistics
 */
export const makeReserveTasks = async (payload = []) => {
  try {
    const response = await post(`${API_RESERVED}`, payload);
    return response;
  } catch (error) {
    console.error(`Error while making the task reserved:`, error);
    throw error;
  }
};


/**
 * Get knowledge base usage statistics
 * @param {Object} payload - payload body
 * @returns {Promise<Object>} Promise resolving to usage statistics
 */
export const fetchTaskDetails = async (payload) => {
  try {
    const response = await post(`${API_URL}/fetch`, payload);
    return response;
  } catch (error) {
    console.error(`Error while fetching the task details:`, error);
    throw error;
  }
};



/**
 * Get knowledge base usage statistics
 * @param {Object} payload - payload body
 * @returns {Promise<Object>} Promise resolving to usage statistics
 */
export const saveTask = async (payload) => {
  try {
    const response = await post(`${API_SAVE}`, payload);
    return response;
  } catch (error) {
    console.error(`Error while saving the task details:`, error);
    throw error;
  }
};


/**
 * Get knowledge base usage statistics
 * @param {Object} payload - payload body
 * @returns {Promise<Object>} Promise resolving to usage statistics
 */
export const submitTask = async (payload) => {
  try {
    const response = await post(`${API_SUBMIT}`, payload);
    return response;
  } catch (error) {
    console.error(`Error while submiting the task details:`, error);
    throw error;
  }
};


